import React, { Component } from 'react'
import { Link } from 'react-router'
import i18next from 'i18next'

import LanguageSwitcher from './LanguageSwitcher'

import styles from './styles/app.scss'

import logo from './../assets/images/wopi360-logo.svg'

export default class Wopi360App extends Component {
  render() {
    const {
      children,
      onChangeLanguage,
      currentAccount,
      currentLanguage,
      hideNonAdminLanguages,
      targetName,
      hideLanguageSwitcher
    } = this.props

    return (
      <div>
        <div className={styles.topBar} />

        <div className={styles.app}>
          <nav>
            {currentAccount && (
              <Link to={'/wopi360'} className={styles.logo360Container}>
                <img src={logo} className={styles.logo360} />

                <span>
                  &larr; {i18next.t('to_admin_view', { lng: currentLanguage, ns: 'wopi360Test' })}
                </span>
              </Link>
            )}

            {!currentAccount && <img src={logo} className={styles.logo360} />}

            {!hideLanguageSwitcher && (
              <div className={styles.languageSwitcherContainer}>
                <LanguageSwitcher
                  onChangeLanguage={onChangeLanguage}
                  currentLanguage={currentLanguage}
                  hideNonAdminLanguages={
                    hideNonAdminLanguages === undefined ? true : hideNonAdminLanguages
                  }
                  isWopi360LanguagesUsed
                />
              </div>
            )}

            {targetName && (
              <div className={styles.targetName}>
                {i18next.t('target_person_is', { lng: currentLanguage, ns: 'wopi360Test' })}{' '}
                {targetName}
              </div>
            )}
          </nav>

          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360App.js